
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#4788C6","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M2.692 1.075L5.696 5.87H0zM11.454 1.636l2.711 4.234H8.739zM20.276 1.075l2.687 4.795h-5.734zM10.26 22.648L6.621 7.584H0zM11.447 20.238l3.218-12.654H8.29zM12.635 22.648L22.963 7.584h-6.654zM15.735 5.22L12.494 0h6.386zM7.265 5.22L4.023 0h6.387z"}})])])
          )
        }
      }
    